import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import MgpStore from "./Store";

let browserLang = navigator.language;
const url = new URL(window.location.href);
const langCd:any = url.searchParams.get("lang");
if(langCd) {
    if(langCd ==="zh") {
        browserLang = "en";
    }else {
        browserLang = langCd;
    }
} else {
    // 언어 코드의 첫 번째 부분만 추출 (ko-KR → ko, en-US → en)
    const primaryLang = browserLang.split('-')[0].toLowerCase();
    
    // // 지원하는 언어 목록
    // const supportedLangs = ['ko', 'zh', 'ja', 'en'];
    
    // // 지원 언어면 사용, 아니면 기본값 'en'
    // browserLang = supportedLangs.includes(primaryLang) ? primaryLang : 'en';
    

     // 지원하는 언어 목록
    // const supportedLangs = ['ko', 'zh', 'ja', 'en'];
         // 지원하는 언어 목록
    const supportedLangs = ['ko', 'en'];
    
    // 지원 언어면 사용, 아니면 기본값 'ko - 2025-11-27 베어브릭 CBT로 인한 일시적인 코드 나중에 윗코드로 복구'
    browserLang = supportedLangs.includes(primaryLang) ? primaryLang : 'en';
}
export interface LangSetStateDataType {
    Lang:string
}

const initialState: LangSetStateDataType = {
    Lang:browserLang
}
const LangSetSlice = createSlice({
    name:"LangSet",
    initialState,
    reducers: {
        LangSetStateChng(state,action:PayloadAction<string>) {
            state.Lang = action.payload;
        }
    }
});

export type AppDispatch = typeof MgpStore.dispatch;
export const {LangSetStateChng} = LangSetSlice.actions;
export default LangSetSlice.reducer;
